module.exports = __webpack_public_path__ + "media/site_templates/www.asbestosremoval.business/images/our_services_1-3b8d2ef0d75abd1a10be89eaf6c9beae.jpg";